import { QRCodeSVG } from "qrcode.react";
import Button from "../button";
import AppBar from "../appbar";
import ApplyQrInfoCard, { type ApplyQrInfoRow } from "./ApplyQrInfoCard";

/* 현장 인증 QR.
 * 표시 전용이라 조회하지 않고 보여줄 값만 받는다.
 */
interface TournamentQrModalProps extends ModalComponentProps {
  title: string;
  /** QR 과 하단 칩에 표시할 인증 코드 */
  code: string;
  rows: ApplyQrInfoRow[];
  isChecking?: boolean;
}

export default function TournamentQrModal({
  close,
  title,
  code,
  rows,
  isChecking = false,
}: TournamentQrModalProps) {
  return (
    <div className="flex flex-col min-h-[100dvh]">
      <AppBar title={title} onBack={isChecking ? () => undefined : close} />

      <div className="flex flex-1 min-h-0 flex-col items-center gap-[20px] overflow-y-auto p-[20px]">
        <div className="flex w-full flex-col items-center gap-[12px] text-center">
          <p className="text-xl font-medium text-black break-keep">
            QR 코드를 인식해 주세요
          </p>
          <p className="text-base font-semibold text-[#8e8e93] break-keep">
            화면의 QR 코드를 QR 리더기에 스캔해 주세요
          </p>
        </div>

        <div className="flex w-full items-center justify-center rounded-[10px] border border-[#e5e5ea] px-[20px] py-[60px]">
          <QRCodeSVG value={code} size={230} level="M" marginSize={0} />
        </div>

        <div className="flex items-center justify-center rounded-full bg-black px-[20px] py-[4px]">
          <p className="text-2xl font-medium text-white break-all">{code}</p>
        </div>

        <ApplyQrInfoCard rows={rows} className="bg-[#f2f2f7]" />
      </div>

      <div className="shrink-0 p-[12px] pb-[calc(12px+var(--safe-area-inset-bottom))]">
        <Button
          className="w-full font-normal"
          variant="white"
          label="닫기"
          disabled={isChecking}
          onClick={close}
        />
      </div>
    </div>
  );
}
